<script>
  import { onMount } from 'svelte';
  import { animeAPI } from '../lib/api';
  import AnimeCard from '../components/AnimeCard.svelte';
  import Loading from '../components/Loading.svelte';

  let animes = [];
  let filteredAnimes = [];
  let loading = true;
  let searchQuery = '';
  let selectedGenre = 'All';
  let allGenres = ['All'];

  onMount(async () => {
    try {
      const response = await animeAPI.getAll();
      animes = response.data?.data || response.data || [];
      
      // Ensure animes is an array
      if (!Array.isArray(animes)) {
        console.warn('Unexpected anime data format:', animes);
        animes = [];
      }
      
      filteredAnimes = animes;
      
      // Extract unique genres
      const genresSet = new Set();
      animes.forEach(anime => {
        if (anime.genres && Array.isArray(anime.genres)) {
          anime.genres.forEach(genre => genresSet.add(genre));
        }
      });
      allGenres = ['All', ...Array.from(genresSet).sort()];
    } catch (error) {
      console.error('Failed to fetch anime:', error);
      animes = [];
      filteredAnimes = [];
    } finally {
      loading = false;
    }
  });

  $: {
    filteredAnimes = animes.filter(anime => {
      if (!anime || !anime.title) return false;
      const matchesSearch = anime.title.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesGenre = selectedGenre === 'All' || (anime.genres && anime.genres.includes(selectedGenre));
      return matchesSearch && matchesGenre;
    });
  }
</script>

{#if loading}
  <Loading />
{:else}
  <div class="min-h-screen">
    <!-- Hero Section -->
    <div class="bg-gradient-to-b from-gray-900 to-gray-950 py-20">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 class="text-5xl font-bold text-center mb-4 animate-fade-in">
          Discover Amazing <span class="text-primary-600">Anime</span>
        </h1>
        <p class="text-xl text-gray-400 text-center mb-8 animate-fade-in">
          Watch your favorite anime series anytime, anywhere
        </p>
        
        <!-- Search Bar -->
        <div class="max-w-2xl mx-auto animate-slide-up">
          <input
            type="text"
            bind:value={searchQuery}
            placeholder="Search anime..."
            class="input"
          />
        </div>
      </div>
    </div>

    <!-- Filters -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="flex flex-wrap gap-2 mb-8">
        {#each allGenres as genre}
          <button
            on:click={() => selectedGenre = genre}
            class="px-4 py-2 rounded-full text-sm font-medium transition-all {selectedGenre === genre ? 'bg-primary-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}"
          >
            {genre}
          </button>
        {/each}
      </div>

      <!-- Anime Grid -->
      {#if filteredAnimes.length === 0}
        <div class="text-center py-20">
          <p class="text-2xl text-gray-400">No anime found</p>
        </div>
      {:else}
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {#each filteredAnimes as anime (anime.id)}
            <AnimeCard {anime} />
          {/each}
        </div>
      {/if}
    </div>
  </div>
{/if}
